module.exports = __webpack_public_path__ + "v4assets/circle-network.ae5e9ceff022f9ae2418b1935cd3db4b.png";